import React, { Component } from 'react';
import { Checkbox, Form } from 'semantic-ui-react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { TrackedCheckbox } from 'Components';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { ReactTableColumnProperties } from 'Common/Constants';
import { CreateEditTruckRouteScheduleEnum } from 'Common/FieldEnum';
import { CreateEditPageEnum } from 'Common/Constants/Enumeration/CommonEnum';

class TruckRouteScheduleGrid extends Component {
  static propTypes = {
    truckRouteListData: PropTypes.array,
    truckRouteListDataLoading: PropTypes.bool,
    truckRouteScheduleDetailData: PropTypes.object,
    isNewEdit: PropTypes.bool,
  };

  static defaultProps = {
    truckRouteListData: [],
    truckRouteListDataLoading: false,
    truckRouteScheduleDetailData: null,
    isNewEdit: false,
  };

  state = {
    routeIds: [],
    sorted: [],
    filtered: [],
    page: 0,
  };

  columns = [
    {
      Header: currentRows => {
        const {
          input: { value },
        } = this.props;
        const dataObjs = currentRows.data;
        const filteredData = [];
        const checkAllIds = [];
        _.forEach(dataObjs, obj => {
          const id = obj[CreateEditTruckRouteScheduleEnum.Id]
            ? obj[CreateEditTruckRouteScheduleEnum.Id]
            : obj._original[CreateEditTruckRouteScheduleEnum.Id];
          if (value.indexOf(id) === -1) {
            filteredData.push(id);
          } else {
            checkAllIds.push(id);
          }
        });
        return (
          <Checkbox
            style={{ marginTop: 10 }}
            checked={Boolean(
              dataObjs.length && checkAllIds.length === dataObjs.length
            )}
            onChange={(e, data) => {
              e.preventDefault();
              e.stopPropagation();
              this.handleHeaderLevelCheckBox(
                filteredData,
                data.checked,
                dataObjs
              );
            }}
          />
        );
      },
      Cell: props => {
        const { original } = props;
        return (
          <div style={{ textAlign: 'center' }}>
            <TrackedCheckbox
              initialValue={
                this.state.routeIds.indexOf(
                  original[CreateEditTruckRouteScheduleEnum.Id]
                ) !== -1
              }
              checked={
                this.props.input.value.indexOf(
                  original[CreateEditTruckRouteScheduleEnum.Id]
                ) !== -1
              }
              onChange={(e, data) => {
                this.handleChangeCheckbox(original, data.checked);
              }}
            />
          </div>
        );
      },
      accessor: CreateEditTruckRouteScheduleEnum.Id,
      width: 150,
      sortable: false,
    },
    {
      Header: 'Route',
      accessor: CreateEditTruckRouteScheduleEnum.Description,
      ...ReactTableColumnProperties,
    },
    {
      Header: 'Type',
      accessor: CreateEditTruckRouteScheduleEnum.Type,
      ...ReactTableColumnProperties,
    },
  ];

  componentDidMount() {
    if (
      this.props.truckRouteScheduleDetailData &&
      this.props.isNewEdit === CreateEditPageEnum.EDIT
    ) {
      this.setState({
        routeIds: this.props.truckRouteScheduleDetailData[
          CreateEditTruckRouteScheduleEnum.RouteIds
        ],
      });
    }
  }
  handleHeaderLevelCheckBox = (data, checked, dataObjs) => {
    const { input } = this.props;
    const tableRows = [...input.value, ...data];
    const remove = [...tableRows];
    _.forEach(dataObjs, obj => {
      const id = obj[CreateEditTruckRouteScheduleEnum.Id]
        ? obj[CreateEditTruckRouteScheduleEnum.Id]
        : obj._original[CreateEditTruckRouteScheduleEnum.Id];
      const index = remove.indexOf(id);
      if (index !== -1) {
        remove.splice(index, 1);
      }
    });
    if (checked) {
      this.props.input.onChange(tableRows);
    } else {
      this.props.input.onChange(remove);
    }
  };

  handleChangeCheckbox = (original, checked) => {
    const { input } = this.props;
    if (input && input.value) {
      const formValues = input.value.length ? [...input.value] : [];
      const index = formValues.indexOf(
        original[CreateEditTruckRouteScheduleEnum.Id]
      );
      if (checked && index === -1) {
        formValues.push(original[CreateEditTruckRouteScheduleEnum.Id]);
      } else if (index > -1) {
        formValues.splice(index, 1);
      }
      this.props.input.onChange(formValues);
    }
  };
  onSortedChange = (sorted, column, shiftKey) => {
    this.setState({ sorted, page: 0 });
  };
  onFilteredChange = (filtered, column) => {
    this.setState({ filtered, page: 0 });
  };
  onPageChange = page => {
    this.setState({ page });
  };
  onPageSizeChange = (currentPageSize, currentPage) => {
    this.setState({
      page: currentPage,
    });
  };

  render() {
    const { truckRouteListData, truckRouteListDataLoading } = this.props;
    return (
      <Form.Field>
        <ReactTable
          minRows={0}
          defaultPageSize={10}
          data={truckRouteListData}
          noDatatext={'No rows found'}
          resizable={false}
          className="-striped -highlight modalGrid"
          columns={this.columns}
          defaultFilterMethod={caseInsensitiveFilter}
          loading={truckRouteListDataLoading}
          sorted={this.state.sorted}
          onSortedChange={this.onSortedChange}
          filtered={this.state.filtered}
          onFilteredChange={this.onFilteredChange}
          page={this.state.page}
          onPageChange={this.onPageChange}
          onPageSizeChange={this.onPageSizeChange}
        />
      </Form.Field>
    );
  }
}

export default TruckRouteScheduleGrid;



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/components/createedittruckrouteschedule/TruckRouteScheduleGrid.js